import * as React from 'react';
import { styled } from '@mui/system';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import { Container, Item } from 'Components/Grid';
import { fm } from 'Components/FormatMessage';

const StyledHistory = styled('div')({});

const TherapyHistoryRowData = ({ document }: IOwnProps): React.JSX.Element => (
  <StyledHistory>
    <Container alignItems="center">
      <Item xs={3}>
        {document.therapyClassification ? (
          <HistoryRowBasicItem
            header={fm('therapy.therapyClassification.title')}
            value={
              <div style={{ fontWeight: 600 }}>
                {fm(`therapy.therapyClassification.opts.${document.therapyClassification}`)}
              </div>
            }
          />
        ) : (
          document.therapyTypes && (
            <HistoryRowBasicItem
              header={<div id={'therapyTypeTitle'}>{fm('therapy.therapyTypes')}</div>}
              value={
                <div style={{ fontWeight: 600 }} id={'therapyType'}>
                  {document.therapyTypes === 'others'
                    ? (document.otherTherapyType ?? '')
                    : fm(`therapy.opts.${document.therapyTypes}`)}
                </div>
              }
            />
          )
        )}
      </Item>
      <Item xs={5}>
        {document.therapyClassification && document.therapyTypes ? (
          <HistoryRowBasicItem
            header={fm('therapy.therapyTypes')}
            value={<div style={{ fontWeight: 600 }}>{fm(`therapy.opts.${document.therapyTypes}`)}</div>}
          />
        ) : undefined}
      </Item>
    </Container>
  </StyledHistory>
);

interface IOwnProps {
  document: IDocumentWithTypeV2<'therapy'>;
}

export default TherapyHistoryRowData;
